<template>
  <v-toolbar>
    <div class='header'>
      <div class='header__lead'>
        <div>{{ lead.fullname || 'Name' }}</div>
        /
        <div>{{ lead.gender }}</div>
        /
        <div>{{ lead.age }}</div>
        /
        <div>{{ lead.city }}</div>
        /
        <div>{{ lead.state }}</div>
      </div>

      <div class='header__actions'>
        <v-btn color='info'>
          <v-icon>mdi-magnify</v-icon>
          Needs
        </v-btn>

        <v-btn color='info'>
          <v-icon>mdi-message</v-icon>
          Objection
        </v-btn>

        <v-btn color='info'>
          <v-icon>mdi-email</v-icon>
          Email a Quote
        </v-btn>

        <v-btn color='purple'>
          <v-icon>mdi-alarm-snooze</v-icon>
          Reminders
        </v-btn>

        <v-btn color='purple'>
          <v-icon>mdi-account-multiple-plus</v-icon>
          Referral
        </v-btn>
      </div>
    </div>

  </v-toolbar>
</template>

<script>
export default {
  name: 'AgentHeader',
  props: {
    lead: {
      type: Object,
    },
  },
  methods: {},
};
</script>

<style scoped lang='scss'>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &__lead {
    display: flex;
    gap: 5px;
    font-weight: 600;
  }

  &__actions {
    display: flex;
    gap: 10px;
  }

  &__toolbar {

  }


}
</style>
